import * as React from 'react';
import { styled } from '~ui-kit/styled-components';
import { Box } from './box.component';
import { Img } from './img.component';

const Icon = styled(Img)`
  vertical-align: middle;
  max-height: 68px;
  max-width: 68px;
`;

interface Props {
  srcImg: string;
}

export const IconBox: React.SFC<Props> = ({ srcImg, children }) => {
  if (srcImg == null || srcImg == undefined) return <div />;

  return (
    <Box mt={['20px']} align="center" justify="center" flexDirection="column" width={['100%']}>
      <Icon src={srcImg} />
      {children}
    </Box>
  );
};
